package br.com.texeratx.boardgametimeapp.data.model.expansion

import kotlinx.serialization.Serializable

@Serializable
data class ExpansionDTO(
    val id: Long,
    val name: String,
    val gameId: Long,
    val imageUrl: String?,
    val bggUrl: String?,
    val status: Int
)
